import { useNavigate } from 'react-router-dom';
import { useAudio } from '../context/AudioContext';
import { Button } from './ui/button';
import { Lock, ShoppingCart, X } from 'lucide-react';

export default function BuyToUnlockPrompt() {
  const navigate = useNavigate();
  const { currentTrack, showBuyPrompt, dismissBuyPrompt, TRACK_PREVIEW_DURATION } = useAudio();

  if (!showBuyPrompt || !currentTrack) return null;

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[100] p-4" data-testid="buy-to-unlock-prompt">
      <div className="bg-[#0a0a0a] border border-[#FFDA33] max-w-md w-full p-6 text-center relative">
        {/* Close button */}
        <button 
          onClick={dismissBuyPrompt}
          className="absolute top-4 right-4 text-[#888888] hover:text-white"
        >
          <X size={20} />
        </button>
        
        {/* Lock Icon */}
        <div className="w-16 h-16 mx-auto mb-4 bg-[#FFDA33]/20 rounded-full flex items-center justify-center">
          <Lock size={32} className="text-[#FFDA33]" />
        </div>
        
        {/* Title */}
        <h2 className="text-white font-['Chakra_Petch'] uppercase text-xl mb-2">
          Preview Ended
        </h2>
        
        {/* Message */}
        <p className="text-[#888888] font-mono text-sm mb-4">
          You've listened to the {TRACK_PREVIEW_DURATION}-second preview of this track.
          Purchase to unlock the full version.
        </p>
        
        {/* Track Info */}
        <div className="bg-[#111111] border border-[#1a1a1a] p-4 mb-6">
          <p className="text-white font-['Chakra_Petch'] uppercase truncate">
            {currentTrack.title}
          </p>
          <p className="text-[#888888] font-mono text-sm mt-1">
            by {currentTrack.artist}
          </p>
          <p className="text-[#00CCFF] font-mono text-lg mt-2">
            ${currentTrack.price?.toFixed(2) || '1.99'}
          </p>
        </div>
        
        {/* Actions */}
        <div className="flex gap-3">
          <Button
            onClick={dismissBuyPrompt}
            variant="outline"
            className="flex-1 rounded-none border-[#1a1a1a] text-[#888888] hover:text-white"
          >
            Maybe Later
          </Button>
          <Button
            onClick={() => {
              dismissBuyPrompt();
              navigate(`/track/${currentTrack.slug || currentTrack.id}`);
            }}
            className="flex-1 rounded-none bg-[#FFDA33] text-black hover:bg-[#ffdd33] font-['Chakra_Petch'] uppercase"
            data-testid="buy-track-btn"
          >
            <ShoppingCart size={16} className="mr-2" />
            Buy Now
          </Button>
        </div>
      </div>
    </div>
  );
}
